import { Injectable } from '@angular/core';
import { AccountService } from 'src/app/pages/account/services/account.service';

@Injectable({
	providedIn: 'root',
})
export class AnalyticsService {
	constructor(private accountService: AccountService) {}

	/**
	 * Fires an analytics event using the Zaraz tracking library.
	 * @param eventName - The name of the event to track.
	 * @param data - Additional data associated with the event (optional).
	 */
	fireAnalyticsEvent(eventName: string, data?: any): void {
		try {
			// Get the Zaraz tracking library from the window object
			const zaraz = (window as any)?.zaraz;
			// Track the event using Zaraz
			zaraz?.track(eventName, data);
		} catch (error) {
			// Log an error message if tracking fails
			console.error(
				'Error while tracking analytics event:',
				'Event: ' + eventName + ' | Error: ' + error
			);
		}
	}

	/**
	 * Opens the cookie settings modal using the Zaraz tracking library.
	 */
	openCookieSettings() {
		try {
			// Get the Zaraz tracking library from the window object
			const zaraz = (window as any)?.zaraz;
			let locale = this.getLangLocale('WD_locale');
			zaraz?.set('__zarazConsentLanguage', locale);
			// Show the consent modal using Zaraz
			zaraz?.showConsentModal();
		} catch (error) {
			// Log an error message if opening the cookie settings modal fails
			console.error('Error while opening cookie settings modal:', error);
		}
	}

	/**
	 * Opens the cookie settings modal using the Zaraz tracking library.
	 */
	setZarazLanguage() {
		try {
			// Get the Zaraz tracking library from the window object
			const zaraz = (window as any)?.zaraz;
			let locale = this.getLangLocale('WD_locale');
			// Show the consent modal using Zaraz
			zaraz?.set('__zarazConsentLanguage', locale);
		} catch (error) {
			// Log an error message if opening the cookie settings modal fails
			console.error('Error while opening cookie settings modal:', error);
		}
	}

	// Helper function to get a locale value by key from localStorage
	getLangLocale(key: string): string {
		try {
			const locale = localStorage.getItem(key);
			return locale ? locale : 'nl'; // Default to 'nl' if not found
		} catch (error) {
			console.error('Error accessing localStorage:', error);
			return 'nl'; // Default to 'nl' in case of an error
		}
	}
}
